module.exports = __webpack_public_path__ + "fonts/Montserrat-700-21.a37a0a9.woff2";